import { z } from "zod";

/**
 * Env vars used by site code (browser and SSR). Gatsby only inlines `GATSBY_*`
 * vars into the browser bundle, so browser-read vars need that prefix.
 */
const envSchema = z.object({
  GATSBY_FREE_CONSULTATION_CALENDLY_URL: z.url(),
});

const parsed = envSchema.safeParse({
  // Literal `process.env.X` reads so Gatsby can inline them at build time.
  GATSBY_FREE_CONSULTATION_CALENDLY_URL: process.env.GATSBY_FREE_CONSULTATION_CALENDLY_URL,
});

if (!parsed.success) {
  const issues = parsed.error.issues.map((issue) => `${issue.path.join(".")}: ${issue.message}`);
  throw new Error(`Invalid environment variables (see .env.example): ${issues.join("; ")}`);
}

export const env = parsed.data;
